<div class="width-100">
  <div class="grid">
    @if (index == 0) {
      <div class="col-12 md:col-5 lg:col-4 nopadtop">
        <field-tools class="pad-none" [dataTitle]="'Tree' | translate">
          <dm-fieldset-header [backGround]="false">
            <button pButton type="button" icon="icons8-save" class="margin cust-width p-button-primary"
              pTooltip="{{'Save_Que' | translate}}"
              (click)="addRequest()"
            ></button>
            <button pButton type="button" icon="pi pi-list" class="margin cust-width p-button-primary"
              pTooltip="{{'Query_List_1' | translate}}"
              (click)="searchQuery()"
            ></button>
          </dm-fieldset-header>
          <div class="scroll-table">
            <p-tree
              [filter]="true"
              filterPlaceholder="{{'Filter' | translate}}"
              [value]="treeIndex"
              selectionMode="single"
              [(selection)]="selectedFile"
              (onNodeSelect)="nodeSelect($event)"
              (onNodeExpand)="nodeExpand($event)"
              [emptyMessage]="'No_Tree' | translate"
              >
              <ng-template let-node pTemplate="default">
                <span id={{node.key}}>
                  {{ node.label }}
                </span>
              </ng-template>
            </p-tree>
          </div>
        </field-tools>
      </div>
    }
    @if (nbDoc !== 0 && blockedTree === false) {
      <div class="nopadtop position-relative"
        [ngClass]="{'col-12 md:col-7 lg:col-8':displayListResult===false, 'col-12 md:col-12 lg:col-12': displayListResult===true}"
        >
        <div class="right">
          @if (displayListResult === true) {
            <button
              class="btnsize margin-left"
              type="button" pButton
              pTooltip="{{'Return_Res' | translate}}"
              tooltipPosition="left"
              icon="pi icons8-retour" styleClass="p-button-success"
              (click)="returnList()"
            ></button>
          }
          @if (displayCriteria === true && displayListResult === false && allowFullText === true) {
            <button
              class="btnsize margin-left"
              type="button" pButton
              pTooltip={{filterState.message}}
              tooltipPosition="left"
              [ngClass]="filterState.state === true ? 'p-button-warning' : 'p-button-primary'"
              icon="pi icons8-search"
              (click)="onFilterSearch()"
            ></button>
          }
        </div>
        @if (displayRes === true) {
          <displayresult
            class="display-block"
            #dispresult
            [srchMode]="srchMode"
            [resultDisplay]="resultDisplay"
            [btnAction]="true"
            [nbDoc]="nbDoc"
            [listColumns]="listColumns"
            [infoList]="infoList"
            [currentSelectedBsk]="{}"
            [listBskVariable]="[]"
            [basketMoveAll]="[]"
            [curPage]="curPage"
            [request]="currentRequest"
            [isDesktop]="isDesktop"
            [autoDocId]="''"
            [fetchParam]="fetchParam"
            (onReturnResult)="onReturnResult($event)"
            (onAction)="onAction($event)"
            (onNextDocs)="onNextDocs()"
            >
          </displayresult>
        }
      </div>
    }
  </div>
</div>

<treesearchrequest
  #treerequest
  [visible]="displaySearchQuery"
  [requests]="requests"
  [searchPath]="updatePath"
  (onSelectRequest)="selectRequest($event)"
  (onCloseRequest)="closeRequest($event)"
  >
</treesearchrequest>


@if (displaySearch === true) {
  <filterdocs
    [visible]="displaySearch"
    (onFilter)="onClickSearch($event)"
    (onClose)="closeSearch()"
    >
  </filterdocs>
}

